import { EXAM_EVENT_DATA_TEST_ID } from '@e2e/constants/exam-center';
import { Grid, Flex, Text, FormSearchSelection } from '@shared/components';

import { type RoomData } from '../../containers/exam-event-creation-logic/exam-event-creation-logic';
import { RoomSelectionFormField } from '../room-selection-form-field';
export interface LocationFormFieldProps {
  slotProps?: {
    examDate?: {
      isExamDateSelected: boolean;
    };
    province?: {
      isProvinceSelected: boolean;
      isProvincesOptionsLoading: boolean;
      provincesOptions: {
        label: string;
        value: string;
      }[];
      isLocationOptionsLoading: boolean;
      locationsOptions: {
        label: string;
        value: string;
      }[];
      isGetAvailableRoomsLoading: boolean;
    };
    name?: {
      isNameSelected: boolean;
    };
    room?: {
      roomData: RoomData[];
      isRoomSelected?: boolean;
      numberOfExaminees?: number;
      isShowSeatInfo?: boolean;
      roomSelectionError?: string;
    };
  };
}

export default function LocationFormField(props: Readonly<LocationFormFieldProps>) {
  const { slotProps } = props;
  const { examDate, province, name, room } = slotProps ?? {};

  return (
    <Grid
      sx={{
        display: 'grid',
        gridTemplateColumns: '240px 1fr',
        gap: (theme) => theme.spacing(6),
        alignItems: 'start',
      }}
    >
      <Text variant='body1Semibold'>สถานที่สอบ</Text>

      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
        <Grid
          sx={{
            display: 'grid',
            gridTemplateColumns: '240px 1fr',
            gap: (theme) => theme.spacing(4),
          }}
        >
          <FormSearchSelection
            name='location.province'
            options={province?.provincesOptions ?? []}
            loading={province?.isProvincesOptionsLoading}
            required
            label='จังหวัด'
            placeholder='เลือกจังหวัด'
            noOptionsText='ไม่พบจังหวัด'
            disabled={!examDate?.isExamDateSelected}
            data-testid={EXAM_EVENT_DATA_TEST_ID.PROVINCE_DROPDOWN}
          />
          <FormSearchSelection
            name='location.locationName'
            options={province?.locationsOptions ?? []}
            loading={province?.isLocationOptionsLoading}
            required
            label='สถานที่/หน่วยงาน'
            placeholder='เลือกสถานที่สอบ/หน่วยงาน'
            noOptionsText='ไม่พบสถานที่สอบ/หน่วยงาน'
            disabled={!province?.isProvinceSelected}
            data-testid={EXAM_EVENT_DATA_TEST_ID.LOCATION_DROPDOWN}
          />
        </Grid>
        {name?.isNameSelected ? (
          <RoomSelectionFormField
            rooms={room?.roomData as RoomData[]}
            isLoading={slotProps?.province?.isGetAvailableRoomsLoading ?? false}
            disableSeatFormField={!slotProps?.room?.isRoomSelected}
            numberOfExaminees={slotProps?.room?.numberOfExaminees}
            isShowSeatInfo={slotProps?.room?.isShowSeatInfo}
            roomSelectionError={slotProps?.room?.roomSelectionError}
          />
        ) : null}
      </Flex>
    </Grid>
  );
}
